/**
 * 从秒获取时间
 */

const getTimeFromSec = sec => {
  if (!sec) {
    return '00:00'
  }
  let s = parseInt(sec % 60)
  const _min = sec / 60
  let min = parseInt(_min % 60)
  let _h = parseInt(_min / 60)
  min.toString().length < 2 && (min = '0' + min)
  s.toString().length < 2 && (s = '0' + s)
  _h.toString().length < 2 && (_h = '0' + _h)
  let ret = min + ':' + s
  if (_h > 0) {
    ret = _h + ':' + min + ':' + s
  }
  return ret
}

export default getTimeFromSec
